/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../components/BaseCom";
import { withParamsAndNavigate } from "../components/WithParamsAndNavigate";
import Sidebar from "../components/Bridge/Sidebar";


class Home extends BaseCom {
  async componentDidMount() {
    setTimeout(() => this.props.navigate('/login'), 100);
  }

  render() {
    if(!this.state.user) return;
    return (<>
    </>);
  }
}

export default withParamsAndNavigate(Home);
